var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCause(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.992 6.448C2.329 5.78 2.89 4.665 3.219 4a.805.805 0 0 1 .669-.441c1.367-.125 4.243-.339 5.429-.417.547-.036.951.045 1.301.397l2.786 2.8c.251.252.392.593.391.948l-.005 9.035 2.946 2.465 2.719-2.996c.591-.65 1.662-.435 1.942.399L24 24H12l4.063-4.472-6.059-5.071-1.749-1.464 1.96 3.557c.104.188.164.396.178.608l.396 6.045a.748.748 0 0 1-.787.797.79.79 0 0 1-.77-.611l-1.206-5.178a.707.707 0 0 0-.17-.319C7.307 17.301 5.118 15 5.118 15s-2.804 6.666-3.561 8.525c-.113.277-.374.475-.748.475A.81.81 0 0 1 0 23.197c0-.146 1.745-8.569 2.322-11.638.07-.371.239-.717.49-1l1.08-1.217L.389 6.41c-.507-.425.137-1.192.642-.767l.961.805Zm6.854 5.735 1.8 1.507 1.952 1.634-1.061-5.948-2.691 2.807ZM2.885 7.195l1.671 1.398 2.791-3.146-2.73-.183-1.732 1.931ZM14.538 0a2.446 2.446 0 1 1 0 4.89 2.446 2.446 0 0 1 0-4.89Z",
    clipRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCause);
export default __webpack_public_path__ + "static/media/cause.ae2057660eac0a7c289c735395073a98.svg";
export { ForwardRef as ReactComponent };